export const needPrfTerm = ['DS01', 'DS02', 'DS03', 'DS04', 'DS05', 'DS11']

